import { toast } from "react-toastify";
import { ComponentService } from "../Services/Axios/Api";
import { generateDynamicCSS } from "../ComponentsMap";

class ColSection {
    data = {};
    constructor() {
        this.data = {
            id: '',
            ComponentName: 'ColSection',
            direction: 'normal',
            leftColumn: {
                imageUrl: '',
                animation: {
                    animationType: 'fade-right',
                    animationDuration: '800',
                    animationDelay: '0',
                },
            },
            rightColumn: {
                title: '',
                description: '',
                animation: {
                    animationType: 'fade-left',
                    animationDuration: '800',
                    animationDelay: '0',
                },
                buttons: [
                    {
                        id: 1,
                        type: "button",
                        button: {
                            text: 'Learn More',
                            link: '/about',
                            type: 'link',
                            buttonType: 'primary',
                            className: 'ColSectionBtn',
                            style: {},
                        },
                    }
                ]
            },
            style: {
                ColSection: {
                    backgroundColor: '#ffffff',
                },
                ColSectionTitle: {
                    color: '#000000',
                },
                ColSectionDescription: {
                    color: '#666666',
                },
                ColSectionImage: {
                    borderRadius: '0px'
                }
            }
        };
    }

    // ID
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Component Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(name) { this.data.ComponentName = name; }

    // Direction (layout)
    getDirection() { return this.data.direction || 'normal'; }
    setDirection(direction) { this.data.direction = direction; }

    // Left Column Properties
    getLeftColumn() { return this.data.leftColumn; }
    setLeftColumn(leftColumn) { this.data.leftColumn = leftColumn; }

    getImageUrl() { return this.data.leftColumn.imageUrl; }
    setImageUrl(url) { this.data.leftColumn.imageUrl = url; }

    // Left animation (media)
    getLeftAnimation() { return this.data.leftColumn.animation || { animationType: 'fade-right', animationDuration: '800', animationDelay: '0' }; }
    setLeftAnimation(animation) { this.data.leftColumn.animation = { ...this.getLeftAnimation(), ...animation }; }
    getLeftAnimationType() { return this.getLeftAnimation().animationType; }
    setLeftAnimationType(type) { this.setLeftAnimation({ animationType: type }); }
    getLeftAnimationDuration() { return this.getLeftAnimation().animationDuration; }
    setLeftAnimationDuration(duration) { this.setLeftAnimation({ animationDuration: duration }); }
    getLeftAnimationDelay() { return this.getLeftAnimation().animationDelay; }
    setLeftAnimationDelay(delay) { this.setLeftAnimation({ animationDelay: delay }); }

    // Right Column Properties
    getRightColumn() { return this.data.rightColumn; }
    setRightColumn(rightColumn) { this.data.rightColumn = rightColumn; }

    // Right animation (content)
    getRightAnimation() { return this.data.rightColumn.animation || { animationType: 'fade-left', animationDuration: '800', animationDelay: '0' }; }
    setRightAnimation(animation) { this.data.rightColumn.animation = { ...this.getRightAnimation(), ...animation }; }
    getRightAnimationType() { return this.getRightAnimation().animationType; }
    setRightAnimationType(type) { this.setRightAnimation({ animationType: type }); }
    getRightAnimationDuration() { return this.getRightAnimation().animationDuration; }
    setRightAnimationDuration(duration) { this.setRightAnimation({ animationDuration: duration }); }
    getRightAnimationDelay() { return this.getRightAnimation().animationDelay; }
    setRightAnimationDelay(delay) { this.setRightAnimation({ animationDelay: delay }); }

    getTitle() { return this.data.rightColumn.title; }
    setTitle(title) { this.data.rightColumn.title = title; }

    getDescription() { return this.data.rightColumn.description; }
    setDescription(description) { this.data.rightColumn.description = description; }

    // Buttons Management
    getButtons() { return [...this.data.rightColumn.buttons]; }
    setButtons(buttons) { this.data.rightColumn.buttons = [...buttons]; }
    
    addButton(button) {
        this.data.rightColumn.buttons = [...this.data.rightColumn.buttons, {
            id: this.data.rightColumn.buttons.length + 1,
            type: "button",
            button: {
                text: button.text || 'Button',
                link: button.link || '#',
                type: button.type || 'link',
                buttonType: button.buttonType || 'primary',
                className: button.className || 'ColSectionBtn',
                style: button.style || {},
            },
        }];
    }

    removeButton(id) {
        this.data.rightColumn.buttons = this.data.rightColumn.buttons.filter(btn => btn.id !== id);
    }

    updateButton(id, updatedData) {
        this.data.rightColumn.buttons = this.data.rightColumn.buttons.map(btn => {
            if (btn.id === id) {
                return {
                    ...btn,
                    button: {
                        ...btn.button,
                        text: updatedData.text || btn.button.text,
                        link: updatedData.link || btn.button.link,
                        type: updatedData.type || btn.button.type,
                        buttonType: updatedData.buttonType || btn.button.buttonType,
                        className: updatedData.className || btn.button.className,
                        style: updatedData.style || btn.button.style
                    }
                };
            }
            return btn;
        });
    }

    // Style Properties
    getStyle() { return this.data.style; }
    setStyle(style) { this.data.style = style; }

    getBackgroundColor() { return this.data.style.ColSection.backgroundColor; }
    setBackgroundColor(color) { this.data.style.ColSection.backgroundColor = color; }

    getTitleColor() { return this.data.style.ColSectionTitle.color; }
    setTitleColor(color) { this.data.style.ColSectionTitle.color = color; }

    getDescriptionColor() { return this.data.style.ColSectionDescription.color; }
    setDescriptionColor(color) { this.data.style.ColSectionDescription.color = color; }

    // Data operations
    getData() { return this.data; }
    setData(data) { this.data = data; }

    renderStyles() {
        // Section Styles
        generateDynamicCSS(`ColSection-${this.getId()}`, [
            { backgroundColor: this.data.style.ColSection.backgroundColor }
        ]);

        // Title Styles
        generateDynamicCSS(`ColSectionTitle-${this.getId()}`, [
            { color: this.data.style.ColSectionTitle.color }
        ]);

        // Description Styles
        generateDynamicCSS(`ColSectionDescription-${this.getId()}`, [
            { color: this.data.style.ColSectionDescription.color }
        ]);

        // Image Styles
        generateDynamicCSS(`ColSectionImage-${this.getId()}`, [
            { borderRadius: this.data.style.ColSectionImage.borderRadius }
        ]);
    }

    async load(id) {
        try {
            if(id){
                const response = await ComponentService.getComponentById(id);
                const data =response.data? JSON.parse(response.data) : {};
                this.setData(data);
                this.setId(response.id);
            }else{
                const response = await ComponentService.getComponent(this.data.ComponentName);
                const data = response[0]?.data? JSON.parse(response[0]?.data) : {}  ;
                this.setData(data);
                this.setId(response[0]?.id);
            }
            this.renderStyles();
            return this.data;
        } catch (error) {
            throw new Error(error.response?.data || 'Failed to load column section data');
        }
    }

    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            this.renderStyles();
            return response;
        } catch (error) {
            throw new Error(error.response?.data || 'Failed to save column section data');
        }
    }
}

export const createColSectionInstance = () => new ColSection();
